document.addEventListener("alpine:init", () => {
    Alpine.data("progressiveAccordion", (autoplay) => ({
        active: null,
        tick: null,
        timeout: null,
        duration: autoplay ? autoplay * 1000 : null,
        autoAdvance: autoplay ? true : false,
        items: null,
        i: 0,
        accordion: null,
        init() {
            this.accordion = this.$root;
        },
        advanceItems() {
            this.i = 0;
            this.items = this.$el.querySelectorAll(
                ".Progressive__Accordion__Item"
            );
   
            this.active = this.items[this.i].id;
            this.timeout;
            clearTimeout(this.timeout);
            

            this.advance();
        },

        advance() {
            this.resetProgress();


            if (this.autoAdvance) {
                const currentItemVertical = this.items[this.i - 1]?.querySelector(".Progressive__Accordion__progress-vertical");
                const currentItemHorizontal = this.items[this.i - 1]?.querySelector(".Progressive__Accordion__progress-horizontal");
                
                // Reset the progress bar for the previous item
                if (currentItemVertical) {
                    currentItemVertical.style.transitionDuration = "0ms"; // Remove transition
                    currentItemVertical.style.height = "0"; // Shrink vertical bar
                }

                if (currentItemHorizontal) {
                    currentItemHorizontal.style.transitionDuration = "0ms"; // Remove transition
                    currentItemHorizontal.style.width = "0"; // Shrink horizontal bar
                }
        
                // Handle end of the loop
                if (this.i >= this.items.length) {
                    this.i = 0; // Restart loop
                }
        
                const nextItemVertical = this.items[this.i]?.querySelector(".Progressive__Accordion__progress-vertical");
                const nextItemHorizontal = this.items[this.i]?.querySelector(".Progressive__Accordion__progress-horizontal");
                this.active = this.items[this.i].id;
        
                // Set the progress bar for the current item
                if (nextItemVertical) {
                    nextItemVertical.style.transitionDuration = this.duration + "ms"; // Apply transition duration
                    nextItemVertical.style.height = "100%"; // Fill vertical bar
                }

                if (nextItemHorizontal) {
                    nextItemHorizontal.style.transitionDuration = this.duration + "ms"; // Apply transition duration
                    nextItemHorizontal.style.width = "100%"; // Fill horizontal bar
                }
        
                // Dispatch event
                this.$dispatch("pegasus-pa-item-selected", {
                    id: this.items[this.i].id,
                    parent: this.$root,
                });
        
                // Increment index and set timeout for next advance
                clearTimeout(this.tick);
                this.i++;
                this.timeout = setTimeout(() => { this.advance() }, this.duration);
            }
        },
        
        changeItem(item) {
            // Handle manual change: clear progress and stop auto-advance
            this.active = item;
            this.autoAdvance = true;

            this.i = this.getI(item);

            clearTimeout(this.timeout);

            this.advance();

            // Dispatch event for manual selection
            this.$dispatch("pegasus-pa-item-selected", { id: item, parent: this.$root });
        },

        getI(item) {
            const itemElement = this.accordion.querySelector(`#${item}`);
            const parentElement = itemElement.parentElement;

            return Array.from(parentElement.children).indexOf(itemElement);
        },

        resetProgress() {
            this.items.forEach((item) => {
                const vertical = item.querySelector(".Progressive__Accordion__progress-vertical");
                const horizontal = item.querySelector(".Progressive__Accordion__progress-horizontal");

                if (vertical) {
                    vertical.style.transitionDuration = "0ms"; // Remove transition
                    vertical.style.height = "0"; // Shrink vertical bar
                }

                if (horizontal) {
                    horizontal.style.transitionDuration = "0ms"; // Remove transition
                    horizontal.style.width = "0"; // Shrink horizontal bar
                }
            });
        }
    }));
});
